module.exports = __webpack_public_path__ + "img/SurrealityCompound2.915126f7.png";